import React, { useEffect, useState } from 'react'
import {
  Card,
  Title, Box, ActionIcon, Skeleton, Grid,
  Button, Flex, Input, SegmentedControl
} from '@mantine/core'

import { useCustomer } from '../store/useCustomer'
import ModalCustomers from '../components/Customers/Modal'
import { HiOutlineSearch } from 'react-icons/hi'
import { get_records } from '../utils/apis/records'
import ModalViewRecords from '../components/Customers/ModalViewRecords'
import ModalConfirm from '../components/Customers/ModalConfirm'
import ModalRenovation from '../components/Home/Modal'
import CustomersTable from '../components/Customers/CustomersTable'

import { notifications } from '@mantine/notifications'

const Customers = () => {
  const { customers, loading, getCustomersList, deleteCustomer } = useCustomer();
  const [ searchText, setSearchText ] = useState('')
  const [ contractFilter, setContractFilter ] = useState('Todos')
  const [ items, setItems ] = useState([]);
  const [ item, setItem ] = useState(null)
  const [ isEditable, setIsEditable ] = useState(false)
  const [ isOpen, setIsOpen ] = useState(false);
  const [ isOpenConfirm, setIsOpenConfirm ] = useState(false);
  const [ itemConfirm, setItemConfirm ] = useState(null);
  const [ selectedAccount, setSelectedAccount ] = useState(null);
  const [ records, setRecords ] = useState(null);
  const [ openRecord, setOpenRecord ] = useState(false);
  const [ openManualRenovation, setOpenManualRenovation ] = useState(false)

  useEffect(() => {
    getCustomersList();
  }, [])

  useEffect(() => {
    applyFilters(searchText, contractFilter);
  }, [customers, searchText, contractFilter])

  const applyFilters = (text, contract) => {
    let result = [...customers];

    // Filter by contract type
    if (contract !== 'Todos') {
      result = result.filter(item => item.type_contract === contract);
    }

    // Filter by search text
    if (text) {
      const filters = text.toUpperCase().split(' ');
      result = result.filter(item => {
        const itemData = `${item.full_name?.toUpperCase() || ''} ${item.email?.toUpperCase() || ''} ${item.num_account?.toUpperCase() || ''}`;
        return filters.every(f => itemData.includes(f));
      });
    }

    setItems(result);
  };

  const openConfirm = (item) => {
    setItemConfirm(item);
    setIsOpenConfirm(true);
  }
  const closeConfirm = () => {
    setIsOpenConfirm(false);
    setItemConfirm(null);
  }
  const removeCustomer = async () => {
    await deleteCustomer({ _id: itemConfirm._id });
    closeConfirm();
  }
  const fetchRecords = async (num_account) => {
    const recordsRes = await get_records({
      num_account: num_account
    });
    setRecords(recordsRes.records.sort((a, b) => new Date(b.created_date) - new Date(a.created_date)));
  }

  const openRecordModal = (num_account) => {
    fetchRecords(num_account);
    setSelectedAccount(num_account);
    setOpenRecord(true);
  }

  const closeRecordModal = () => {
    setOpenRecord(false);
    setSelectedAccount(null);
    setRecords(null);
  }

  const _openManualRenovation = (item) => {
    setItem(item);
    setOpenManualRenovation(true);
  }

  const _closeManualRenovation = async () => {
    setOpenManualRenovation(false);
    setItem(null);
    getCustomersList();
  }

  const onOpen = (item, edit) => {
    setIsOpen(true);
    setItem(item);
    setIsEditable(edit)
  }
  const onClose = () => {
    setIsOpen(false);
    setItem(null);
  }

  const searchBd = (texto) => {
    setSearchText(texto);
  }

  return (
    <>
      <Box className='w-full gap-1 pt-2 px-2'>
        <Flex direction={{ base: 'column', lg: "row" }} justify="space-between" pb="lg" gap="md">
          <Title order={1} my="sm">Clientes </Title>
          
          <Flex direction={{ base: 'column', md: "row" }} justify="flex-end" align="center" gap="md" className="flex-1">
            <SegmentedControl
              value={contractFilter}
              onChange={setContractFilter}
              color="yellow"
              size="md"
              radius="md"
              data={['Todos', 'Prepago', 'Postpago']}
              w={{ base: '100%', md: 'auto' }}
            />

            <Flex align="center" gap="xs" w={{ base: '100%', lg: 300 }}>
              <Input 
                size="lg" 
                w={{ base: '100%', lg: 300 }} 
                variant='filled' 
                placeholder='Buscar por nombre, email o cuenta...' 
                value={searchText} 
                onChange={(e) => searchBd(e.target.value)} 
              />
              <ActionIcon size="xl" variant='light' onClick={() => applyFilters(searchText, contractFilter)}>
                <HiOutlineSearch />
              </ActionIcon>
            </Flex>

            <Button 
              size='md' 
              fullWidth={false} 
              px="xl" 
              onClick={() => onOpen(null, true)}
            >
              Nuevo Cliente
            </Button>
          </Flex>
        </Flex>

        <Flex justify="space-between" w="100%">
          {!loading ? (
            <CustomersTable 
              items={items} 
              onOpen={onOpen} 
              openConfirm={openConfirm} 
              openRecordModal={openRecordModal} 
              _openManualRenovation={_openManualRenovation}
            />
          ) : (
            <Card shadow="sm" p="xl" radius="xl" withBorder mx="md" w="100%">
              <Grid w="100%">
                {[1, 2, 3, 4, 5, 6, 7].map(i => (
                  <Skeleton key={i} height={80} radius="md" my="xs" />
                ))}
              </Grid>
            </Card>
          )}
        </Flex>
      </Box>
      
      <ModalCustomers isOpen={isOpen} onOpen={onOpen} onClose={onClose} item={item} edit={isEditable} />
      <ModalViewRecords isOpen={openRecord} onOpen={openRecordModal} onClose={closeRecordModal} num_account={selectedAccount} records={records} onSyncSuccess={getCustomersList} />
      <ModalConfirm isOpen={isOpenConfirm} onOpen={openConfirm} onClose={closeConfirm} item={itemConfirm} remove={removeCustomer} />
      <ModalRenovation isOpen={openManualRenovation} onOpen={_openManualRenovation} onClose={_closeManualRenovation} item={item} />
    </>
  )
}

export default Customers
